import { __ } from '@wordpress/i18n';
import { registerBlockType, updateCategory } from '@wordpress/blocks';
import TestimonialEditForm from './testimonialForm/form';
import TestimonialEdit from './testimonial/testimonial';
import {
	CategoryIcon,
	TestimonialFormIcon,
	TestimonialIcon,
} from '../assets/testimonialIcons';

/**
 * Register: Real Testimonial Pro Gutenberg Block.
 */
updateCategory( 'testimonial', { icon: <CategoryIcon /> } );

const blocks = [
	{
		name: 'sp-testimonial-pro/shortcode',
		title: __( 'Real Testimonials Pro', 'testimonial-pro' ),
		description: __(
			'Use Real Testimonials Pro to insert a view shortcode (testimonials) in your page',
			'testimonial-pro'
		),
		category: 'testimonial',
		icon: TestimonialIcon,
		edit: TestimonialEdit,
		save: () => null,
	},
	{
		name: 'sp-testimonial-pro/form',
		title: __( 'Testimonials Form', 'testimonial-pro' ),
		description: __(
			'Use Real Testimonials Pro to insert a view shortcode (forms) in your page',
			'testimonial-pro'
		),
		category: 'testimonial',
		icon: TestimonialFormIcon,
		edit: TestimonialEditForm,
		save: () => null,
	},
];

const registerBlockTypeFn = ( options ) => {
	registerBlockType( options.name, options );
};

blocks?.map( ( block ) => registerBlockTypeFn( block ) );
